/**
 * Service: contact
 * It maintains the state of contacts
 * items - contact items of type individual, organization, membership, etc.
 * item: {
 *  id: String
 *  title: String
 *  firstName: String
 *  lastName: String
 *  middleName: String
 *  email: String
 *  phone: String
 *  address: {
 *    streetAddress1: String,
 *    streetAddress2: String,
 *    city: String,
 *    state: String,
 *    country: String,
 *    zipCode: Number
 *  },
 *  name: String <only for membership type>
 *  cardType: String <only for membership type>
 *  customerSource: String <only for membership type>
 * }
 */

angular.module('acme.common.service.contact', [
  'acme.common.service.validate'
])
.service('ContactService', ['ValidateService', function(ValidateService) {

  return {

    contacts: [],

    validators: [],

    init: function() {
      return true;
    },

    setItems: function(items) {
      this.items = items;
    },

    getItems: function() {
      return this.items || [];
    },

    reset: function() {
      this.items = [];
    },

    getItem: function(itemId) {
      var items = this.getItems().filter(function(item) {
        return item.id === itemId;
      });

      return items.length ? items[0] : null;
    },

    //TODO: Check if item has an id and try to update instead
    addItem: function(item) {

      if (!(this.items instanceof Array)) {
        this.items = [];
      }

      if (!this.getItem(item.id)) {
        this.items.push(item);
      } else {
        this.updateItem(item);
      }

    },

    updateItem: function(item) {
      var i, ii,
        items = this.getItems();

      for (i=0, ii=items.length; i < ii; i++) {
        if (item.id === items[i].id) {
          items[i] = item;
          break;
        }
      }
    },

    removeItem: function(itemId) {
      var i, ii,
        index = -1,
        items = this.getItems();

      for (i=0, ii=items.length; i < ii; i++) {
        if (itemId === items[i].id) {
          index = i;
          break;
        }
      }

      if (index > -1) {
        this.items.splice(index, 1);
      }
    },

    getMembershipItems: function() {
      var items = this.getItems().filter(function(item) {
        return item.hasOwnProperty('cardType');
      });

      return items.length ? items[0] : null;
    }

  };

}]);